module.exports = __webpack_public_path__ + "img/Weapon_269.9e56bc03.png";